<div
  class="container-fluid p-0 ng-untouched ng-pristine ng-valid"
  ng-reflect-form="[object Object]"
>
  <h4>Introduction</h4>
  <div class="row">
    <p>
      The Enterprise Suitability ratings presented by the Crop Decision Tool can
      be used as a rough guide as to the likely growth rates your trees will
      achieve if planted on these sites. The tool below can be used to assign
      likely growth rates to the area under each rating, from which estimated
      volumes at harvest age can be derived. The Estimated Mean Annual Increment
      figures provided as defaults are indicative only, and you should seek
      advice from a professional as to the likely growth rates achievable on
      your site.
    </p>
  </div>
  <div class="row">
    <p>
      Note that pine species are generally thinned in Tasmania, either once or
      twice, to achieve a higher quality product at final harvest.
    </p>
  </div>

  <div class="row mt-3">
    <div class="col">
      <label for="speciesSelectionDropdown">Choose Species</label>
      <select
        #selectedCrop
        [formControl]="enterpriseSelect"
        class="form-select mt-1"
        id="speciesSelectionDropdown"
        aria-label="speciesSelectionDropdown"
      >
        @for (row of enterpriseReport(); track row) {
        <option [ngValue]="row">{{ row.crop.label }}</option>
        }
      </select>
    </div>
  </div>

  @if (selectedCropSpecies() !== null) {
  <div [@inOutAnimation] class="row mt-3">
    <div [@inOutAnimation] class="row mt-3" [formGroup]="indicativeYieldForm">
      <div class="col-12">
        <h4 class="m-0 mb-1">Enterprise Suitability Rating</h4>
      </div>

      <div class="mt-3 mb-1">
        <h4 class="m-0 text-green-600 font-semibold">Well suited</h4>
      </div>
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label for="speciesSelectionDropdown">Mapped area (ha)</label>
          <input
            [appDecimalFormatting]
            class="form-control"
            type="number"
            formControlName="mappedWellSuited"
          />
        </div>
        <div>
          <label for="speciesSelectionDropdown">
            Estimated Mean Annual Increment (t/ha/yr)
          </label>
          <input
            (keyup)="formValueUpdateHandler()"
            class="form-control"
            type="number"
            name=""
            formControlName="estimatedWellSuited"
            id="" />
        </div>
      </div>


      <div class="col-12 mt-3 mb-1">
        <h4 class="m-0 text-green-500 font-semibold">Suitable</h4>
      </div>
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label for="speciesSelectionDropdown">Mapped area (ha)</label>
          <input
            [appDecimalFormatting]
            class="form-control"
            type="number"
            formControlName="mappedSuitable"
          />
        </div>
        <div>
          <label for="speciesSelectionDropdown"
            >Estimated Mean Annual Increment (t/ha/yr)</label
          >
          <input
            (keyup)="formValueUpdateHandler()"
            class="form-control"
            type="number"
            formControlName="estimatedSuitable"
          />
        </div>
      </div>

      <div class="col-12 mt-3 mb-1">
        <h4 class="m-0 text-yellow-600 font-semibold">Moderately Suitable</h4>
      </div>
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label for="speciesSelectionDropdown">Mapped area (ha)</label>
          <input
            [appDecimalFormatting]
            class="form-control"

            type="number"
            formControlName="mappedModeratelySuitable"
          />
        </div>
        <div>
          <label for="speciesSelectionDropdown"
            >Estimated Mean Annual Increment (t/ha/yr)</label
          >
          <input
            (keyup)="formValueUpdateHandler()"
            class="form-control"
            type="number"
            formControlName="estimatedModeratelySuitable"
          />
        </div>
      </div>

      <div class="col-12 mt-3 mb-1">
        <h4 class="m-0 text-red-600 font-semibold">Unsuitable</h4>
      </div>
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label for="speciesSelectionDropdown">Mapped area (ha)</label>
          <input
            [appDecimalFormatting]
            class="form-control"

            type="number"
            formControlName="mappedUnsuitable"
          />
        </div>
        <div>
          <label for="speciesSelectionDropdown"
            >Estimated Mean Annual Increment (t/ha/yr)</label
          >
          <input
            (keyup)="formValueUpdateHandler()"
            class="form-control"
            type="number"
            formControlName="estimatedUnsuitable"
          />
        </div>
      </div>
    </div>

    <div class="col-12 mt-5 mb-3">
      <div class="row">
        <div class="col">
          <label for="speciesSelectionDropdown" class="pe-1">Total Area:</label>
          <span>{{ totalArea() | toPrecision }}</span>
        </div>
      </div>
    </div>

    <div class="col-12 mt-3">
      <div class="flex flex-col gap-4">
        <!-- Header Row -->
        <div
          class="flex flex-wrap gap-4 text-sm font-semibold text-gray-700 border-b border-gray-200 pb-2"
        >
          <div class="flex-1 min-w-[150px]">Average MAI</div>
          <div class="flex-1 min-w-[150px]">Final Harvest Age</div>
          <div class="flex-1 min-w-[150px]">Total Harvestable Volume*</div>
          <div class="flex-1 min-w-[150px]">
            Total Harvestable Volume Per Hectare*
          </div>
        </div>

        <!-- Data Row -->
        <div class="flex flex-wrap gap-4 items-center">
          <div class="flex-1 min-w-[150px] font-medium">
            {{ averageMAI() | toPrecision }}
          </div>
          <div class="flex-1 min-w-[150px]">
            <input
              [formControl]="finalHarvestAgeControl"
              class="form-control border border-gray-300 w-full"
              type="number"
            />
          </div>
          <div class="flex-1 min-w-[150px] font-medium">
            {{ harvestableVolume() | toPrecision }}
          </div>
          <div class="flex-1 min-w-[150px] font-medium">
            {{ harvestableVolumePerHectare() | toPrecision }}
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>
